import { dom } from 'js/dom';
import { set_defaults } from 'js/utils';
import Hooks from 'js/hooks';

export default class Buttons {
	constructor(el, options = {}) {
		this.el = dom.get(el);

		this.hooks = new Hooks();

		this.options = set_defaults(
			{
				multiple: false,
				// unselect: true,
			},
			options,
		);

		this.init_buttons();
	}

	init_buttons() {
		const init_button = (btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				this.update(btn);
			});
		};

		this.buttons = this.el.querySelectorAll('.button');

		this.buttons.forEach(init_button);
	}

	update(btn) {
		if (!this.options.multiple) {
			if (this.current) {
				this.current.classList.remove('selected');
				if (this.current === btn) {
					this.current = null;
					return this.hooks.do('update');
				}
			}
		}

		this.current = btn;

		const is_selected = btn.classList.contains('selected');

		btn.classList[is_selected ? 'remove' : 'add']('selected');

		this.hooks.do('update');
	}

	get_value() {
		const value = [];

		this.buttons.forEach((btn) => {
			if (btn.classList.contains('selected')) {
				value.push(btn.dataset.value);
			}
		});

		return value;
	}
}
